<template>
  <v-dialog max-width="500" :model-value="isVisible" persistent>
    <v-card :title="dialogTitle">
      <v-card-text>
        <div class="mb-4">
          <div class="text-caption text-medium-emphasis">Current payer</div>
          <div class="font-weight-medium">{{ currentPayerLabel }}</div>
        </div>

        <v-form ref="formRef" v-model="valid">
          <v-select
            name="newPayerUser"
            label="New payer (existing member)"
            :items="memberEmails"
            placeholder="Select a member"
            v-model="newPayerUserEmail"
            :rules="[rules.required]"
            variant="outlined"
            density="default"
            no-data-text="No other members on this plan"
          />
        </v-form>

        <div class="text-caption text-medium-emphasis">
          Ownership can only be transferred to an existing member of this plan. The current payer stays on as a member — seat count is unchanged.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="cancel" :disabled="isLoading">
          Cancel
        </v-btn>
        <v-btn rounded="lg" size="large" color="primary" variant="flat" @click="save" :loading="isLoading">
          Change payer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  customer: {
    type: Object,
    default: null
  },
  memberEmails: {
    type: Array,
    default: () => []
  },
  isVisible: {
    type: Boolean,
    required: true
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['save', 'cancel'])

const formRef = ref(null)
const valid = ref(true)
const newPayerUserEmail = ref(null)

const rules = {
  required: (value) => !!value || 'Required.'
}

const dialogTitle = computed(() => {
  return props.customer?.company ? `Change payer — ${props.customer.company}` : 'Change payer'
})

const currentPayerLabel = computed(() => {
  if (!props.customer) {
    return ''
  }
  const payer = props.customer.payerUser
  const email = payer?.email || props.customer.payerUserEmail
  const name = payer ? `${payer.firstname || ''} ${payer.lastname || ''}`.trim() : ''

  return name ? `${name} (${email})` : email
})

const save = async () => {
  const { valid: isValid } = await formRef.value.validate()
  if (!isValid) {
    return
  }
  emit('save', {
    enterpriseCustomerId: props.customer.id,
    newPayerUserEmail: newPayerUserEmail.value
  })
}

const cancel = () => {
  emit('cancel')
}

watch(() => props.isVisible, (visible) => {
  if (visible) {
    newPayerUserEmail.value = null
    if (formRef.value) {
      formRef.value.resetValidation()
    }
  }
})
</script>
